require('./_set-species')('Array');



//////////////////
// WEBPACK FOOTER
// /usr/src/site-blog/node_modules/core-js/modules/es6.array.species.js
// module id = 382
// module chunks = 99